module.exports = __webpack_public_path__ + "static/media/Video_caption_3.a4c230d8.png";